import { FC, useEffect, useState } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export const ZGComp: FC = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const [lineAni, setLineAni] = useState('');

    useEffect(() => {
        AniContainer.create({
            triggerElement: `.${css.ZGComp} .data-box-right`,
            triggerHook: 1,
            offset: 200,
            onEnter() {
                setLineAni('line-ani');
            },
            onLeave() {
                setLineAni('');
            },
        });
    }, []);

    return (
        <div className={css.ZGComp}>
            <div className="data-box">
                <div className="data-box-left">
                    <div className="subtitle">{t('sec16_subtitle')}</div>
                    <div className="title">{t('sec16_title')}</div>
                    <div className="desc">{t('sec16_desc')}</div>
                </div>
                <div className="data-box-right">
                    <div className="first-box">
                        <div className="first-box-left">
                            <div className="line">
                                <div className={`line-inner ${lineAni}`}></div>
                            </div>
                            <div className="line-desc">{t('sec16_gas')}</div>
                        </div>
                        <div className="first-box-right">
                            <div className="line-title">
                                {t.rich('sec16_gas_quieter', {
                                    sub: (text: string) => <div className="subtitle">{text}</div>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="second-box">
                        <div className="second-box-left">
                            <div className="line">
                                <div className={`line-inner ${lineAni}`}></div>
                            </div>
                            <div className="line-desc">{t('sec16_ps')}</div>
                        </div>
                        <div className="second-box-right">
                            <div className="line-title">
                                {t.rich('sec16_ps_quieter', {
                                    sub: (text: string) => <div className="subtitle">{text}</div>,
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="img-box-wrapper">
                <div className="img-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zg.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/zg.jpg')}
                        alt={t('sec16_title')}
                        aria-label={t('sec16_title')}
                    />
                    <div className="text-wrapper">
                        <p className="green">{t('sec16_white')}</p>
                        <p className="white">{t('sec16_green')}</p>
                    </div>
                </div>
            </div>
            <div className="tip-box">{t('sec16_tips')}</div>
        </div>
    );
};
